import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import ReactMarkdown from "react-markdown";
import { FAQ_PAGE } from "@/constants/testIds";
import { Footer } from "@/components/Footer";
import { FAQ_CONTENT } from "@/content/legalContent";

export default function Faq() {
  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between px-6 md:px-12 py-6">
        <Link to="/" className="flex items-center gap-2">
          <ShieldCheck className="w-7 h-7 text-petroleum" strokeWidth={1.5} />
          <span className="font-heading text-xl font-bold text-charcoal tracking-tight">CERH</span>
        </Link>
      </header>
      <section className="px-6 md:px-12 pb-20 max-w-3xl mx-auto">
        <div data-testid={FAQ_PAGE.content} className="prose prose-slate max-w-none">
          <ReactMarkdown
            components={{
              h1: ({ children }) => <h1 className="font-heading text-3xl font-bold text-charcoal mb-4">{children}</h1>,
              h2: ({ children }) => <h2 className="font-heading text-xl font-semibold text-charcoal mt-8 mb-3">{children}</h2>,
              p: ({ children }) => <p className="text-sm text-charcoal/75 leading-relaxed mb-3">{children}</p>,
              ul: ({ children }) => <ul className="list-disc pl-5 text-sm text-charcoal/75 space-y-1.5 mb-3">{children}</ul>,
              li: ({ children }) => <li>{children}</li>,
              strong: ({ children }) => <strong className="font-semibold text-charcoal">{children}</strong>,
              hr: () => <hr className="my-8 border-petroleum/10" />,
            }}
          >
            {FAQ_CONTENT}
          </ReactMarkdown>
        </div>
      </section>
      <Footer />
    </div>
  );
}
